// extracted by mini-css-extract-plugin
module.exports = {"container":"LanguageSelector_container__OoVKd","localeSelection":"LanguageSelector_localeSelection__1NS2U"};